import { TextInput } from '@client/new/pages/promotions/view/components/TextInput';
import { Textarea } from '@design-system/components/textarea/textarea';
import { Col, Row } from '@design-system/components/grid/grid';
import * as styles from './Tabata.css';
import { PropsWithChildren } from 'react';
import { useTabataVM } from '../../view-model/workout.viewModel';
import { TabataVM } from '../../view-model/workouts.domain';
import { AutoplayedActions } from './common/AutoplayedActions';
import { InfoBox } from './common/InfoBox';
import { Typography } from '@design-system/components/typography/typography';
import { Tooltip } from '@design-system/components/tooltip/tooltip';
import { workoutVM } from '@client/new/pages/workout/WorkoutEdit';
import { Errors } from '@client/new/pages/promotions/view/components/Errors';
import { TimeInputWithControls } from '@design-system/components/time-input';

const TabataForm = (p: TabataVM) => {
  const vm = workoutVM.useValue();
  return (
    <Row className={styles.basicForm} gap="l">
      <Col>
        <TextInput required label="Title" {...p.register('name')} />
        <Textarea
          label="Description"
          style={{ minHeight: 128 }}
          {...p.register('description')}
        />
      </Col>
      <Col gap="l">
        <Row spreadEvenly>
          <Typography variant="body" size="medium">
            Goal:
          </Typography>
          <Typography variant="body" size="medium" fontWeight="normal">
            1 round
          </Typography>
        </Row>
        <Row spreadEvenly>
          <Typography variant="body" size="medium">
            Duration:
          </Typography>
          <Typography variant="body" size="medium" fontWeight="normal">
            <Tooltip
              title="The duration here is calculated based on the workout and rest times for each exercise "
              variant="dark"
              arrow
              tooltipProps={{
                maxWidth: 157,
              }}
            >
              <span>{vm.getDuration(p.id)}</span>
            </Tooltip>
          </Typography>
        </Row>
        <Row>
          <InfoBox title="How does it work?" collapsible defaultOpen={false}>
            Pick how long you want your users to do an exercise, how long they
            should rest in between, and how many sets they'll do. You'll also be
            able to define a longer rest at the end of each exercise. These
            values can be changed later on.
          </InfoBox>
        </Row>
        <Row>
          <Col>
            <Typography variant="body" size="medium">
              Rest at the end
            </Typography>
            <Typography variant="body" size="small" fontWeight="normal">
              Enter a time or use the +/- controls or input value. The time will
              increase in 10-second steps.
            </Typography>
            <TimeInputWithControls {...p.register('longRest')} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export const Tabata = (p: PropsWithChildren<{ id: string }>) => {
  const workout = workoutVM.useValue();
  const tabata = useTabataVM(workout, p.id);
  return (
    <Col className={styles.content}>
      <Errors data={tabata.errors} />
      <TabataForm {...tabata} />
      <div className={styles.list}>{p.children ? p.children : null}</div>
      <AutoplayedActions id={p.id} />
    </Col>
  );
};
